export const EMAILTEMPLATE_PLAIN = 'EMAILTEMPLATE_PLAIN'
